<template lang="html">
    <div class="audit">

        <PageTitle
            :text="pageTitle">
        </PageTitle>

        <div class="layout-width padding" v-if="userSite">

            <div style="padding-bottom: 20px">
                <p>{{ pageDescription }}</p>
            </div>

            <div
                class="padding shadow"
                style="padding-top:40px; margin-bottom:20px;">
                <el-form
                    ref="auditForm"
                    :model="form"
                    :rules="rules"
                    label-width="200px">

                    <el-form-item
                        label="Date de l'audit"
                        prop="date">
                        <el-col :span="10">
                            <el-date-picker
                                v-model="form.date"
                                type="datetime"
                                placeholder="Date de l'audit"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp
                                text="Date de l'audit">
                            </FormHelp>
                        </el-col>
                    </el-form-item>

                    <el-form-item
                        label="Limite de selection"
                        prop="motorbox_count"
                    >
                        <el-col :span="10">
                            <el-input-number
                                v-model.number="form.motorbox_count"
                                :min="0"
                                style="width:100%">
                            </el-input-number>
                        </el-col>
                        <el-col :span="2">
                            <FormHelp text="Nombre maximum de moteurs pouvant être sélectionnés pour cet audit"></FormHelp>
                        </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            icon="el-icon-check"
                            @click="save">
                            Enregistrer
                        </el-button>
                        <el-button
                            icon="el-icon-close"
                            @click="$router.go(-1)">
                            Annuler
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/partials/ui/PageTitle';
import FormHelp from '@/components/partials/ui/FormHelp';
import schwartz from 'schwartz';

export default {
    name: 'Motor',
    components: {
        PageTitle,
        FormHelp
    },
    data () {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: 'Aujourd\'hui',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: 'Hier',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: 'Il y a une semaine',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            form: {
                date: '',
                motorbox_count: 0,
            },
            rules: {
                date: [
                    { required: true, message: 'La date de l\'audit est obligatoire', trigger: 'blur' }
                ],
                motorbox_count: [
                    { required: true, message: 'La limite de sélection est obligatoire', trigger: 'change' }
                ],
            },
        };
    },
    computed: {
        ...mapGetters([
            'currentSite',
            'currentUser',
            'getFormattedAuditDate',
            'auditByUid'
        ]),
        userSite () {
            if (this.currentSite){
                return this.currentSite
            }
            this.$router.push({name: 'Home'})
        },
        currentAudit() {
            return this.auditByUid(this.$route.params.auditUid)
        },
        pageTitle () {
            return this.$route.params.auditUid ? `Audit du ${this.getFormattedAuditDate(this.currentAudit)}` : 'Nouvel audit'
        },
        pageDescription () {
             return this.$route.params.auditUid ? `Modifer les informations de l\'audit du ${this.getFormattedAuditDate(this.currentAudit)}` : 'Ajouter un nouvel audit'
        },
    },
    created () {
        if (this.$route.params.auditUid) {
            this.form = Object.assign({}, this.form, this.currentAudit);
        }
    },
    methods: {
        save () {
            this.$refs.auditForm.validate( valid => {
                if (valid) {
                    const method = this.$route.params.auditUid
                        ? 'patchItem' : 'createItem';
                    const item = this.$route.params.auditUid
                        ? Object.assign({
                            uid: this.currentAudit.uid,
                            url: this.currentAudit.url
                        }, this.form)
                        : this.form;

                    item.site_uid = this.userSite.uid;
                    item.user_uid = this.userSite.customer_uid;
                    item.can_view_users = [this.userSite.customer_uid];
                    item.can_admin_users = [this.userSite.customer_uid];
                    // item.site_uid = this.currentSite.uid
                    // save in concrete
                    this.$store.dispatch(method, {
                        item,
                        model: 'audit',
                        url: 'audit/'
                    // eslint-disable-next-line
                    }).then(res => {
                        this.$notify({
                            title: 'Enregistré',
                            message: 'Audit enregistré avec succès',
                            type: 'success'
                        });
                        this.$router.go(-1);
                    }).catch(err => {
                        // console.log(err);
                        this.$notify({
                            title: 'Erreur',
                            message: err.message,
                            type: 'error'
                        });
                    });
                } else {
                    this.$notify({
                        title: 'Erreur',
                        message: 'Merci de vérifiez que les champs sont bien renseignés',
                        type: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/page/Home/Audit.vue